import { messages } from "../contactFilters/messages"
import { getCustomFilters } from "../customFilters"
import { SectionOrFilter } from "../filterTypes"

export const companyListTotals = []
export const companyListFields = [
    "name",
    "nameAnalyzed",
    "nameKeyword",
    "email",
    "emailKeyword",
    "organizationName",
    "organizationNameAnalyzed",
    "organizationNameKeyword",
    "nameSort",
    "phoneNumber",
    "address",
    "citySort",
    "cityKeyword",
    "phoneNumberKeywordSearch",
    "note",
    "noteKeyword",
    "noteAnalyzed",
]

export const getCompanyFilters = (context) => {
    const orgCustomFilters = getCustomFilters(context, "organizations")
    const availableFilters: SectionOrFilter[] =
    [
        {
            section: context.intl?.formatMessage(messages["most_used_filters"]),
        },
        {
            nameId: "isArchived",
            label: context.intl?.formatMessage(messages["is_archived"]),
            filterMatch: "isArchived",
            type: "boolean",
            placeHolder: "Show archived",
            initialValue: "",
            initialSelect: "is",
        },
        {
            nameId: "customerLabelIds",
            label: context.intl?.formatMessage(messages["customer_type_placeholder"]),
            filterMatch: "labelIds",
            type: "select",
            typeOfSelect: "label-select",
            multi: false,
            placeHolder: context.intl?.formatMessage(messages["customer_type_placeholder"]),
            labelName: "customerTypeId",
            labelType: "customer-type",
            initialValue: [],
            initialSelect: "isOneOf"
        },
        {
            nameId: "updatedAt",
            label: context.intl?.formatMessage(messages["updated_at"]),
            filterMatch: "updatedAt",
            type: "date",
            initialValue: { startDate: null, endDate: null },
            initialSelect: "is"
        },
        {
            nameId: "organizationId",
            label: context.intl?.formatMessage(messages["company_id"]),
            filterMatch: "organizationId",
            type: "select",
            typeOfSelect: "organization-select",
            initialValue: "",
            initialSelect: "isOneOf"
        },
        {
            nameId: "organizationName",
            label: context.intl?.formatMessage(messages["company_name"]),
            filterMatch: "organizationNameKeyword",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "phoneNumber",
            label: context.intl?.formatMessage(messages["company_phone_number"]),
            filterMatch: "phoneNumberKeyword",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "taxNumber",
            label: context.intl?.formatMessage(messages["company_tax_number"]),
            filterMatch: "taxNumber",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "email",
            label: context.intl?.formatMessage(messages["company_email"]),
            filterMatch: "emailKeyword",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "defaultTax",
            label: context.intl?.formatMessage(messages["company_default_tax"]),
            filterMatch: "taxId",
            type: "select",
            typeOfSelect: "tax-select",
            multi: true,
            initialValue: [],
            initialSelect: "isOneOf"
        },
        {
            nameId: "recurringStatementEnabled",
            label: context.intl?.formatMessage(messages["recurring_statement_enabled"]),
            filterMatch: "recurringStatementEnabled",
            type: "boolean",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "recurringStatementNextCreationDate",
            label: context.intl?.formatMessage(messages["recurring_statement_next_creation_date"]),
            filterMatch: "recurringStatementNextCreationDate",
            type: "date",
            initialValue: { startDate: null, endDate: null },
            initialSelect: "is"
        },
        {
            nameId: "recurringStatementSendEmail",
            label: context.intl?.formatMessage(messages["recurring_statement_send_email_enabled"]),
            filterMatch: "recurringStatementSendEmail",
            type: "boolean",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "recurringStatementCapturePayment",
            label: context.intl?.formatMessage(messages["recurring_statement_capture_payment_enabled"]),
            filterMatch: "recurringStatementCapturePayment",
            type: "boolean",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "recurringStatementAttachPdf",
            label: context.intl?.formatMessage(messages["recurring_statement_attach_pdf_enabled"]),
            filterMatch: "recurringStatementAttachPdf",
            type: "boolean",
            initialValue: "",
            initialSelect: "is"
        },
    ]
    return availableFilters.concat(orgCustomFilters)

}


// WEBPACK FOOTER //
// ./src/common/search-filter/search/companyFilters/companyFilters.ts